import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';

export function ToolTip({
  children,
  visible,
  title,
  width,
  position,
  className,
  arrowClassName,
  textContainerClassName,
}) {
  return (
    <div className={styles['tooltip-container']}>
      <div className={styles['children-container']}>
        {children}
      </div>
      {
        (visible && title)
        && (
          <div
            className={cn(
              styles['help-popup'],
              className,
              {
                [styles['right']]: position === 'right',
                [styles['left']]: position === 'left',
                [styles['top']]: position === 'top',
                [styles['bottom']]: position === 'bottom',
              }
            )}
          >
            <div
              className={cn(
                styles['arrow-top'],
                arrowClassName,
                { [styles['arrow-left']]: position === 'right' },
                { [styles['arrow-right']]: position === 'left' },
                { [styles['arrow-bottom']]: position === 'top' },
                { [styles['arrow-top-left']]: position === 'bottom' }
              )}
            />
            <div className={cn(styles['text-container'], textContainerClassName)}>
              <p
                className={cn(styles['help-text'], { [styles['help-text-right']]: position === 'right' })}
                style={width && { width: `${width}` }}
              >
                {title}
              </p>
            </div>
          </div>
        )
      }
    </div >
  );
}

ToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object ]).isRequired,
  width: PropTypes.string,
  position: PropTypes.string,
  className: PropTypes.string,
  arrowClassName: PropTypes.string,
  textContainerClassName: PropTypes.string,
};

ToolTip.defaultProps = {
  visible: true,
  textContainerClassName: null,
};
